import { AppState } from '../../reducers/index';

export const isRedtailActivitySavingSelector = (state: AppState) => state.redtail?.activities?.isActivitySaving;
